import _ from 'lodash'

// Validation function for expiration date
export const validateExpirationDate = (value: string): string | null => {
  if (!value || value.trim() === '') {
    return 'Expiration date is required'
  }

  // Check format: MM / YY
  const formatRegex = /(0[1-9]|10|11|12) \/ [0-9]{2}$/

  if (!formatRegex.test(value)) {
    return 'Invalid expiration date format'
  }

  const mm_yy = _.split(value, ' / ')

  if (mm_yy.length !== 2) {
    return 'Invalid expiration date format'
  }

  const twoDigitYear = mm_yy[1]
  const expirationMonth = Number(mm_yy[0])

  const today = new Date()
  const thisYear = Number(today.getFullYear())
  const thisMonth = Number(today.getMonth() + 1) // Jan = 0, Dec = 11
  const thisCentury = today.getFullYear().toString().slice(0, 2)

  const expirationYear = Number(`${thisCentury}${twoDigitYear}`)
  const fiftyYearsLater = thisYear + 50

  const isValidMonth = expirationMonth >= 1 && expirationMonth <= 12
  const isValidYear = expirationYear >= thisYear && expirationYear <= fiftyYearsLater

  const isFutureDate =
    expirationYear > thisYear || (expirationYear === thisYear && expirationMonth >= thisMonth)

  if (!isValidMonth || !isValidYear || !isFutureDate) {
    return 'Expiration date must be in the future'
  }

  return null
}

export const waitForToken = (token: string, maxWaitTime = 5000): Promise<string> => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now()

    const checkToken = () => {
      if (token) {
        resolve(token)
      } else if (Date.now() - startTime > maxWaitTime) {
        reject(new Error('Tokenization timeout - please try again'))
      } else {
        setTimeout(checkToken, 100) // Check every 100ms
      }
    }

    checkToken()
  })
}
